import { render, staticRenderFns } from "./Contents.vue?vue&type=template&id=4d7bb23d&scoped=true&"
import script from "./Contents.vue?vue&type=script&lang=js&"
export * from "./Contents.vue?vue&type=script&lang=js&"
import style0 from "./Contents.vue?vue&type=style&index=0&id=4d7bb23d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7bb23d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d7bb23d')) {
      api.createRecord('4d7bb23d', component.options)
    } else {
      api.reload('4d7bb23d', component.options)
    }
    module.hot.accept("./Contents.vue?vue&type=template&id=4d7bb23d&scoped=true&", function () {
      api.rerender('4d7bb23d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/dashboard/Contents.vue"
export default component.exports